export const HomeResult = {
	ActiveInStock: 0,
	InflateInStock: 1,
	ActiveHighlighted: 2,
	InflateHighlighted: 3
}